module.exports = __webpack_public_path__ + "static/img/Icon1@2x.10b697ce.png";